import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { RoomListAccessService } from '../room-list/room-list-access.service';

export interface LastMessage {
  sender: string;
  senderId: string; // TODO wtf (wofür)?
  body: string;
  timestamp: Date | null;
  unreadMessageCount: number;
  isMentioned: boolean;
}

@Injectable({
  providedIn: 'root'
})
/**
 * Service zur Bereitstellung der letzten Nachricht innerhalb eines Raumes
 * Begründung: keine AFO, da helfer Service
 */
export class LastMessageService {
  private readonly roomListAccessService = inject(RoomListAccessService);

  /**
   * Aktualisiert mit jeder ChatState-Änderung die Map von Room-ID zu letzter Nachricht.
   */
  lastMessageDict$: Observable<Map<string, LastMessage>> = this.roomListAccessService.getRoomInfos$().pipe(
    map(
      roomInfos =>
        new Map<string, LastMessage>(
          roomInfos.map(roomInfo => {
            let senderId = roomInfo.lastMessage?.sender;
            let sender: string | undefined;
            if (senderId) {
              const member = roomInfo.modelRoom.members.find(m => m.mxid === senderId);
              sender = member?.name;
            }
            // TODO Wieso Raumname?
            senderId ??= roomInfo.name ?? '';
            sender ??= roomInfo.name ?? '';
            return [
              roomInfo.roomId,
              {
                sender,
                senderId,
                body: roomInfo.lastMessage?.body ?? '',
                timestamp: roomInfo.lastMessage ? new Date(roomInfo.lastMessage.ts) : null,
                unreadMessageCount: roomInfo.unreadMessageCount,
                isMentioned: roomInfo.isMentioned
              }
            ];
          })
        )
    )
  );

  /*
  lastMessageDict$: Observable<Map<string, LastMessage>> = mapMap(
    this.chatStoreService.getState$().pipe(map(state => state.rooms)),
    chatRoom => {
      let lastEvent: MatrixEvent | undefined;
      const chatMessages = chatRoom.messages;
      if (chatMessages && chatMessages.length > 0) {
        // Finde letzte RoomMessage
        for (let i = chatMessages.length - 1; i >= 0; --i) {
          const event = chatMessages[i].curr;
          if (
            event.getType() === EventType.RoomMessage ||
            event.getType() === EventType.RoomRedaction
          ) {
            lastEvent = event;
            break;
          }
        }
      }

      return lastEvent
        ? this.buildMessageData(chatRoom.apiRoom, lastEvent)
        : this.buildEmptyMessageData(chatRoom.apiRoom);
    }
  );
  */

  /**
   * Erzeugt eine Message aus den Daten des letzten RoomMessage Events.
   */
  /*
  private buildMessageData(room: ApiRoom, lastEvent: MatrixEvent): LastMessage {
    const sender = lastEvent.sender?.rawDisplayName ?? room.name;
    const senderId = lastEvent.sender?.userId ?? room.name;
    const timestamp = lastEvent.getDate();
    let body: string;

    if (lastEvent.getType() === EventType.RoomRedaction) {
      body = `Die Nachricht wurde gelöscht von ${sender} am ${timestamp?.toLocaleString(
        'de-DE',
        {
          hour: '2-digit',
          minute: '2-digit'
        }
      )}.`;
    } else {
      const replaced =
        lastEvent.getRelation()?.rel_type === RelationType.Replace;
      const content = lastEvent.getContent();
      body = replaced
        ? (content['m.new_content']?.['body'] ??
          lastEvent.getClearContent()?.['body'] ??
          '')
        : (content?.['body'] ?? '');
    }

    return { sender, senderId, body, timestamp };
  }
  */

  /**
   * Baut eine leere Message.
   */
  /*
  private buildEmptyMessageData(room: ApiRoom): LastMessage {
    return {
      sender: room.name,
      senderId: room.name,
      body: '',
      timestamp: null
    };
  }
  */
}
